import { useContext } from 'react';
import { EditOutlined } from '@ant-design/icons';
import MyTable from "components/UIElements/MyTable";
import { AuthContext } from 'shared/context/auth-context';
import { useHistory } from "react-router-dom";


export default function PackingListResults({ endPoint, deviceTypeId }) {
  
  
  const { roleUser } = useContext(AuthContext);
  const history = useHistory();
  /* eslint-disable jsx-a11y/anchor-is-valid */
  const columns = [
    {
      key: 'action',
      render: (record) =>
        roleUser === "GT" ?
          <EditOutlined style={{ fontSize: "20px" }} onClick={() => history.push({
            pathname: `/choices/device-settings/${record.deviceImei}`,
            state: { record }
          })}
          />
          : null,
      showForDeviceType: [1,3]

    },
    {
      title: 'Ημερομηνία Εισαγωγής',
      dataIndex: 'dateCreated',
      key: 'dateCreated',
      showForDeviceType: [1,3]
    },
    {
      title: 'ΙΜΕΙ Συσκευής',
      dataIndex: 'deviceImei',
      key: 'deviceImei',
      showForDeviceType: [1,3]
    },
    {
      title: 'ΙΜSΙ Sim Κάρτας',
      dataIndex: 'simImsi',
      key: 'simImsi',
      showForDeviceType: [1]

    },
    {
      title: 'Αριθμός Κιβωτίου',
      dataIndex: 'parcelId',
      key: 'parcelId',
      showForDeviceType: [1,3]
    },
    {
      title: 'Κατάσταση Πακέτου',
      dataIndex: 'status',
      key: 'status',
      showForDeviceType: [1,3]
    },
    {
      title: 'Μπαταρία (V)',
      dataIndex: 'batteryVoltage',
      key: 'batteryVoltage',
      showForDeviceType: [3],
      sorter: true,
    render: value => 
      value ? (
        <span style={{ color: Number(value) <= 2.65 ? 'red' : 'inherit' }}>
          {Number(value)} V
        </span>
      ) : null,
    },
     {
      title: 'Ενημέρωση μπαταρίας',
      dataIndex: 'batteryVoltageLastUpdated',
      key: 'batteryVoltageLastUpdated',
      showForDeviceType: [3],
      
    },
  ].filter(item => item.showForDeviceType.indexOf(deviceTypeId) !== -1);



  return <MyTable endPoint={endPoint} columns={columns} style={{ cursor: "pointer" }} />
}